export const carnetUrls = {
  all: 'carnets-de-notes',
  details: (id: string) => `${carnetUrls.all}/${id}`,
  evaluations: (cdnId: string) => `${carnetUrls.details(cdnId)}/evaluations`,
  evaluationDetail: (cdnId: string, evaluationId) =>
    `${carnetUrls.evaluations(cdnId)}/${evaluationId}`,
  carnetEleve: (cdnId: string, eleveId: string) =>
    `${carnetUrls.details(cdnId)}/eleves/${eleveId}/evaluations`,
  livretEleve: () => carnetUrls,
  allLivrets: (cdnId: string) => `${carnetUrls.details(cdnId)}/livrets`,
  livretDetails: (cdnId: string, id: string) =>
    `${carnetUrls.allLivrets(cdnId)}/${id}`,
  livretEleveDetails: (cdnId: string, id: string, eleveId: string) =>
    `${carnetUrls.livretDetails(cdnId, id)}/eleves/${eleveId}`,
};
